import React, { useState, useEffect } from 'react';
import { getFirestore, doc, onSnapshot } from 'firebase/firestore';
import './SubscriberStats.css';

const SubscriberStats = () => {
  const [totalSubscribers, setTotalSubscribers] = useState(0);

  useEffect(() => {
    const db = getFirestore();
    
    const unsubscribe = onSnapshot(doc(db, 'analytics', 'pushStats'), (doc) => {
      if (doc.exists()) {
        const data = doc.data();
        setTotalSubscribers(data.totalSubscribed || 0);
      }
    });

    return () => unsubscribe();
  }, []);

  return (
    <div className="subscriber-stats">
      <div className="stat-card">
        <h2>Abonnés aux notifications</h2>
        <div className="stat-value">{totalSubscribers}</div>
      </div>
    </div>
  );
};

export default SubscriberStats; 